import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ApiGetEnabledStatusByProjectId, ApiGetEnabledStatusByStageId, ApiGetEnabledStatusResponse, FormDefinitions } from '../../api/dtos';

const getData = (response?: SWRResponse<ApiGetEnabledStatusResponse, ApiGetEnabledStatusResponse>) => {
    return response?.data?.status
}
const getError = (response?: SWRResponse<ApiGetEnabledStatusResponse, ApiGetEnabledStatusResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useApiActivityStatus = (parentFormId?: number, parentFormDefinition?: FormDefinitions, configuration?: SWRConfiguration<ApiGetEnabledStatusResponse, ApiGetEnabledStatusResponse>) => {
    const request = useMemo(() => {
        if(!parentFormDefinition || !parentFormId) {
            return undefined;
        }
        return () => {
            return parentFormDefinition == FormDefinitions.Stage ? 
                new ApiGetEnabledStatusByStageId({
                    stageId: parentFormId
                }) :
                new ApiGetEnabledStatusByProjectId({
                    projectId: parentFormId
                });
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useApiActivityStatus;